import { UploadAssetFieldMui } from '@app/modules/assets/screens/upload/components/UploadAssetFieldMui';
import { audiogramMessages } from '@app/modules/admin/screens/fragments/manage/audiogram/messages';
import { Box, Stack, Typography } from '@mui/material';
import {
  CheckboxButtonGroup,
  RadioButtonGroup,
  TextFieldElement,
  useFormContext,
} from 'react-hook-form-mui';
import { FormattedMessage, useIntl } from 'react-intl';

export function AudiogramStyleFields({ fieldsPrefix = '' }: { fieldsPrefix?: string }) {
  const { watch } = useFormContext();
  const { $t } = useIntl();
  const backgroundType = watch(`${fieldsPrefix}backgroundType`) as string;

  return (
    <Stack>
      <Box mb={2}>
        <CheckboxButtonGroup
          label={$t(audiogramMessages.formatsToGenerate)}
          required
          name={`${fieldsPrefix}variants`}
          options={[
            { id: '1x1', label: $t(audiogramMessages.formatSquare) },
            { id: '16x9', label: $t(audiogramMessages.formatHorizontal) },
            { id: '9x16', label: $t(audiogramMessages.formatVertical) },
          ]}
          row
        />
      </Box>

      <Stack spacing={3}>
        <TextFieldElement
          label={$t(audiogramMessages.titleColor)}
          fullWidth
          required
          type="color"
          name={`${fieldsPrefix}titleColor`}
          sx={{ width: '200px' }}
        />
        <TextFieldElement
          label={$t(audiogramMessages.captionsColor)}
          fullWidth
          required
          type="color"
          name={`${fieldsPrefix}captionsTextColor`}
          sx={{ width: '200px' }}
        />
        <TextFieldElement
          label={$t(audiogramMessages.visualizerColor)}
          fullWidth
          required
          type="color"
          name={`${fieldsPrefix}visualizerColor`}
          sx={{ width: '200px' }}
        />
        <Stack spacing={0}>
          <Typography variant="subtitle2">
            <FormattedMessage {...audiogramMessages.backgroundType} />
          </Typography>
          <RadioButtonGroup
            name={`${fieldsPrefix}backgroundType`}
            options={[
              { id: 'solid', label: $t(audiogramMessages.solidColor) },
              { id: 'image', label: $t(audiogramMessages.image) },
            ]}
            row
          />
        </Stack>
        <Stack spacing={0}>
          {backgroundType === 'solid' ? (
            <TextFieldElement
              label={$t(audiogramMessages.backgroundColor)}
              fullWidth
              required
              type="color"
              name={`${fieldsPrefix}backgroundColor`}
              sx={{ width: '200px' }}
            />
          ) : (
            <UploadAssetFieldMui
              name={`${fieldsPrefix}backgroundImageUrl`}
              label={$t(audiogramMessages.backgroundImage)}
              successText={$t(audiogramMessages.imageUploadSuccess)}
              assetLink
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
